const { customAlphabet } = require('nanoid');

export const createUniqueId = (size=10) => {
  return customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', size)()
}

export const createTimeBasedUniqueNumber = () => {
  return `${new Date().getMilliseconds() + Math.floor(Math.random() * 100000)}`
}
